import ImageIcon from "@mui/icons-material/Image";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { colors } from "./colors";
export const filesFormats = {
  image: {
    list: ["bmp", "webp", "jpg", "jpeg", "png", "gif", "svg", "ico"],
    Icon: ImageIcon,
    color: colors.green,
  },
  text: {
    list: ["txt", "rtf", "doc", "docx", "odt", "wpd", "csv"],
    Icon: TextSnippetIcon,
    color: colors.blue,
  },
  pdf: {
    list: ["pdf"],
    Icon: PictureAsPdfIcon,
    color: colors.red,
  },
};
